import type { BusinessSubscription, BusinessInvitation } from "lens-platform-sdk";

type InvitationAssignMethod = "email" | "activation-link";

export type PendingSubscriptionInvitation = BusinessInvitation & {
  state: "pending";
  subscriptionId: string;
  subscription?: BusinessSubscription;
  assignMethod?: InvitationAssignMethod;
};

/**
 * @returns true if `BusinessInvitation` that has `subscriptionId` and state is `pending`
 */
export const isPendingSubscriptionInvitation = (
  invitation: BusinessInvitation,
): invitation is PendingSubscriptionInvitation => invitation.state === "pending" && Boolean(invitation.subscriptionId);
